module.exports = __webpack_public_path__ + "img/modal-document-confirm.68df5478.svg";